(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    

class HeroSlider {
  constructor(el) {
    this.el           = el;
    this.slides       = Array.from(el.querySelectorAll('.hero__slide'));
    this.bars         = Array.from(el.querySelectorAll('.hero__progress-bar'));
    this.prevBtn      = el.querySelector('.hero__arrow--prev');
    this.nextBtn      = el.querySelector('.hero__arrow--next');
    this.current      = 0;
    this.autoplay     = el.dataset.autoplay === 'true';
    this.speed        = (parseInt(el.dataset.speed, 10) || 5) * 1000;
    this.timer        = null;
    this._bindEvents();
    if (this.autoplay) this._startAutoplay();
    // Kick off fill animation on first bar
    this._resetBars(0);
  }

  _resetBars(activeIndex) {
    this.bars.forEach((bar, i) => {
      // Strip all state classes
      bar.classList.remove('hero__progress-bar--active', 'hero__progress-bar--completed');
      bar.setAttribute('aria-selected', 'false');

      // Force CSS animation restart by cloning the fill element
      const fill = bar.querySelector('.hero__progress-bar__fill');
      if (fill) {
        const newFill = fill.cloneNode(true);
        fill.parentNode.replaceChild(newFill, fill);
      }

      if (i < activeIndex) {
        bar.classList.add('hero__progress-bar--completed');
      } else if (i === activeIndex) {
        bar.classList.add('hero__progress-bar--active');
        bar.setAttribute('aria-selected', 'true');
      }
    });
  }

  _bindEvents() {
    if (this.slides.length <= 1) return;

    this.bars.forEach((bar, i) => {
      bar.addEventListener('click', () => this.goTo(i));
    });

    this.prevBtn?.addEventListener('click', (e) => { e.preventDefault(); this.prev(); });
    this.nextBtn?.addEventListener('click', (e) => { e.preventDefault(); this.next(); });

    // Keyboard
    this.el.setAttribute('tabindex', '-1');
    this.el.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); this.prev(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
    });

    // Pause fill animation on hover/focus
    if (this.autoplay) {
      this.el.addEventListener('mouseenter', () => {
        this.el.classList.add('is-paused');
        this._stopAutoplay();
      });
      this.el.addEventListener('mouseleave', () => {
        this.el.classList.remove('is-paused');
        this._startAutoplay();
      });
      this.el.addEventListener('focusin', () => {
        this.el.classList.add('is-paused');
        this._stopAutoplay();
      });
      this.el.addEventListener('focusout', () => {
        this.el.classList.remove('is-paused');
        this._startAutoplay();
      });
    }

    // Touch / swipe
    let touchStartX = null;
    this.el.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    this.el.addEventListener('touchend', (e) => {
      if (touchStartX === null) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) dx < 0 ? this.next() : this.prev();
      touchStartX = null;
    }, { passive: true });
  }

  goTo(index) {
    const prev = this.current;
    this.current = ((index % this.slides.length) + this.slides.length) % this.slides.length;
    if (prev === this.current) return;

    this.slides[prev].classList.remove('hero__slide--active');
    this.slides[this.current].classList.add('hero__slide--active');

    // Update progress bars
    this._resetBars(this.current);

    document.dispatchEvent(new CustomEvent('hero:slide-change', { detail: { index: this.current } }));

    if (this.autoplay) { this._stopAutoplay(); this._startAutoplay(); }
  }

  next() { this.goTo(this.current + 1); }
  prev() { this.goTo(this.current - 1); }

  _startAutoplay() {
    this._stopAutoplay();
    this.timer = setInterval(() => this.next(), this.speed);
  }

  _stopAutoplay() {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  }

  reinit() {
    this._stopAutoplay();
    this.slides   = Array.from(this.el.querySelectorAll('.hero__slide'));
    this.bars     = Array.from(this.el.querySelectorAll('.hero__progress-bar'));
    this.current  = 0;
    this.slides.forEach((s, i) => s.classList.toggle('hero__slide--active', i === 0));
    this._resetBars(0);
    this._bindEvents();
    if (this.autoplay) this._startAutoplay();
  }
}

/* ── Boot ──────────────────────────────────────────────────── */
const _heroSliders = new Map();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-slideshow="true"]').forEach((el) => {
    _heroSliders.set(el.id, new HeroSlider(el));
  });
});

/* ── Shopify theme-editor hooks ────────────────────────────── */
if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('[data-slideshow="true"]');
    if (el) _heroSliders.set(el.id, new HeroSlider(el));
  });

  document.addEventListener('shopify:block:select', (e) => {
    const section = e.target.closest('[data-slideshow="true"]');
    if (!section) return;
    const sw = _heroSliders.get(section.id);
    if (!sw) return;
    const idx = sw.slides.indexOf(e.target);
    if (idx >= 0) { sw._stopAutoplay(); sw.goTo(idx); }
  });

  ['shopify:block:deselect', 'shopify:block:reorder'].forEach((evt) => {
    document.addEventListener(evt, (e) => {
      const section = e.target.closest('[data-slideshow="true"]');
      if (section) _heroSliders.get(section.id)?.reinit();
    });
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAutoplay(component) {
      if (component.dataset.autoplay !== 'true') return;
      if (component._autoplayInit) return;
      component._autoplayInit = true;

      const delay = parseInt(component.dataset.autoplaySpeed, 10) || 5000;
      let timer = null;

      const tabs = () => Array.from(component.querySelectorAll('[role="tab"]'));

      const activeIndex = () => {
        const all = tabs();
        const idx = all.findIndex(t => t.getAttribute('aria-selected') === 'true');
        return idx >= 0 ? idx : 0;
      };

      const advance = () => {
        const all = tabs();
        if (!all.length) return;
        const next = (activeIndex() + 1) % all.length;
        all[next].click();
      };

      const start = () => {
        stop();
        timer = setInterval(advance, delay);
      };

      const stop = () => {
        clearInterval(timer);
        timer = null;
      };

      // Pause on hover over the whole slideshow section
      component.addEventListener('mouseenter', stop);
      component.addEventListener('mouseleave', start);

      // Manual click resets the timer so it doesn't jump immediately after
      tabs().forEach(tab => {
        tab.addEventListener('click', () => {
          if (timer !== null) start(); // only restart if autoplay is running
        });
      });

      start();
    }

    // Run after the custom element's own connectedCallback has had a chance to fire
    const tryInit = () => {
      document.querySelectorAll('layered-slideshow-component').forEach(initAutoplay);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryInit);
    } else {
      // Small defer so the component's own setup runs first
      setTimeout(tryInit, 0);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
